import { LiveViewRow } from './interfaces';

type TimeSpentFields = Pick<LiveViewRow, 'timeSpentSeconds'|'timeSpentAsOf'|'idle'|'timeSpentFloor'>;

// Seconds of Time Spent to show at `now`: the tool's last report plus the
// time since, unless the tool has stopped counting for inactivity. Never below
// what was already shown, so a lower report pauses the clock rather than
// rewinding it.
export const timeSpentAt = (row: TimeSpentFields, now: Date): number => {
  const sinceReport = !row.idle && row.timeSpentAsOf ? Math.max((now.getTime() - new Date(row.timeSpentAsOf).getTime()) / 1000, 0) : 0;
  return Math.max(Math.floor((row.timeSpentSeconds || 0) + sinceReport), row.timeSpentFloor || 0, 0);
};
